/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Offline_TInputs */



/**
* | output |
* | --- |
* | "Go offline before you leave" |
*
* @param {Tournament_Wiz_Tip_Offline_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_offline_t = /** @type {((inputs?: Tournament_Wiz_Tip_Offline_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Offline_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passez hors ligne avant de partir")
	if (locale === "es") return /** @type {LocalizedString} */ ("Active el modo sin conexión antes de salir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fique offline antes de sair")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai offline prima di partire")
	return /** @type {LocalizedString} */ ("Go offline before you leave")
});